import { render, staticRenderFns } from "./DashMobileAppsInAppPurchase.vue?vue&type=template&id=2865476e&scoped=true&"
import script from "./DashMobileAppsInAppPurchase.vue?vue&type=script&lang=js&"
export * from "./DashMobileAppsInAppPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865476e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
